export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "store_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magasin"])},
        "seller_count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["aucun vendeur"]), _normalize([_interpolate(_named("count")), " vendeur"]), _normalize([_interpolate(_named("count")), " vendeurs"])])},
        "compliance_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conformité magasin"])}
      },
      "en": {
        "store_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store"])},
        "seller_count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["no sellers"]), _normalize([_interpolate(_named("count")), " seller"]), _normalize([_interpolate(_named("count")), " sellers"])])},
        "compliance_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store compliance"])}
      }
    }
  })
}
